// extracted by mini-css-extract-plugin
export var image = "_ik-0";